import { Flex, Grid, Text } from '@chakra-ui/react'

import { WarningIcon } from './icons/WarningIcon'

export interface InsuranceInfoProps {
  label: string
  value: string | number
  isScrolled?: boolean
  hasWarning?: boolean
}

export const InsuranceInfo = ({
  label,
  value,
  isScrolled = false,
  hasWarning = false,
}: InsuranceInfoProps) => {
  return (
    <Grid sx={{ gap: 2 }}>
      <Text
        sx={{
          color: 'primary.50',
          fontSize: { base: 'xs', md: isScrolled ? 'xs' : 'sm' },
        }}
      >
        {label}
      </Text>

      <Flex sx={{ gap: 4 }}>
        <Text
          sx={{
            color: hasWarning ? 'red.500' : 'primary.50',
            fontSize: { base: 'xs', md: isScrolled ? 'xs' : 'sm' },
            fontWeight: 'bold',
          }}
        >
          {value}
        </Text>

        {hasWarning && <WarningIcon sx={{ width: 5, height: 4 }} />}
      </Flex>
    </Grid>
  )
}
